import React from 'react';
import {getCssSizeValue, isStringEmpty} from "@/utils/utils";
import SimpleIconButton, {SIMPLE_ICON_BUTTON_VARIANTS} from "@/components/common/SimpleIconButton";
import PreserveSearchParamsLink from "@/components/common/Links/PreserveSearchParamsLink";
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";

const Wrapper = styled(PreserveSearchParamsLink)`
	position: relative;
	bottom: 0;
	left: 0;
    z-index: 2;
	display: flex;
	width: 100%;
	
	.block {
		width: 100%;
		color: ${({ theme }) => theme.colors.whiteSmoke};
		background: ${({ theme }) => theme.colors.richBlue};
        display: flex;
		align-items: center;
		justify-content: center;
		
    }
	
	.block, .simple-icon-button{
        height: ${getCssSizeValue(62, BREAKPOINTS.MOBILE)};
	}
    .simple-icon-button{
		aspect-ratio: 1;
		width: ${getCssSizeValue(62, BREAKPOINTS.MOBILE)};
	}

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        position: absolute;
		width: auto;
        translate: calc(-1 * var(--paddingX));
        .block{
			width: ${getCssSizeValue(384, BREAKPOINTS.DESKTOP)};
		}
        .block, .simple-icon-button {
            height: ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)};
        }
        .simple-icon-button{
            width: ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)};
        }
    }
`

const Badge = ({ data }) => {
	return !isStringEmpty(data.url) && (
		<Wrapper href={data.url}>
			<div className='block typo-borna typo-borna-108'>{data.text}</div>
			<SimpleIconButton
				rotation={180}
				variant={SIMPLE_ICON_BUTTON_VARIANTS.BIG}
				borderColor="chilliRed"
				bgColor="chilliRed"
			/>
		</Wrapper>
	)
}
export default Badge;
